import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";

import { collection, getDocs } from 'firebase/firestore';
import styles from './AdminRoleManager.module.css';
import Button from '../../ui/Button';

export default function AdminRoleManager() {
  const [email, setEmail] = useState('');
  const [users, setUsers] = useState([]);
  const [result, setResult] = useState('');
  const { notify } = useNotifications();
  const { user, userData, claims } = useAuth();
  const { t } = useTranslation(); 
  
  const promoteFn = httpsCallable(getFunctions(), 'setadminrole');
  const revokeFn = httpsCallable(getFunctions(), 'revokeadminrole');

  const fetchUsers = async () => {
    const snap = await getDocs(collection(firestore, 'userClaims'));
    setUsers(snap.docs.map(d => ({ uid: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchUsers();
  }, [result]);

  const handlePromote = async (uidemail) => {
	const res = await promoteFn({ email: email.trim() || uidemail });
    setResult(res.data.message);
    setEmail('');
  };

  const handleRevoke = async (uid) => {
    const res = await revokeFn({ uid });
    setResult(res.data.message);
  };

  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  return (
 	<>
    <LightNav/>
    <div className={styles.panel}>
      <h2>{t('admin.userRoles')}</h2>
      <div className={styles.form}>
        <input
          type="email"
          value={email}
          placeholder="User email"
          onChange={e => setEmail(e.target.value)}
        />
        <Button variant="primary" onClick={handlePromote}>{t('admin.promoteToAdmin')}</Button>
      </div>
      <div className={styles.result}>{result}</div>

      <table className={styles.table}>
        <thead>
          <tr><th>Email</th><th>Role</th><th>Action</th></tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.uid}>
              <td>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.role === 'user' ? <Button variant="secondary" onClick={() => handlePromote(u.email)}>{t('admin.promote')}</Button>
                  : <Button variant="secondary" onClick={() => handleRevoke(u.uid)}>{t('admin.revoke')}</Button>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
	</>
  );
}
